import { colors } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import typography from './typography';

const theme = createTheme({
  palette: {
    background: {
      default: '#F4F6F8',
      paper: colors.common.white
    },
    primary: {
      contrastText: '#ffffff',
      main: '#5664d2'
    },
    text: {
      // Use a subtle black for better accessibility and softer appearance
      primary: 'rgba(0,0,0,0.87)',
      secondary: '#6b778c'
    }
  },
  components: {
    MuiPaginationItem: {
      variants: [
        {
          props: { variant: 'text' },
          style: {
            borderRadius: '50%!important'
          },
        }
      ]
    },
  },
  shadows,
  typography
});

export default theme;
